export const publish = (data) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.LIFE_CYCLE_EVENT_BUS.trigger(
      'spotlight.content-click',
      data
    );
  }
};
export const publishExchangeAnalytics = (link = '') => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    // Determine cardType based on URL
    const cardType = link.includes('mynavyexchange.com') ? 'navy' : 'aafes';
    window.LIFE_CYCLE_EVENT_BUS.trigger(
      'spotlight.military.content-click',
      { cardType }
    );
  }
};
